import { render } from "./FDDetails.vue?vue&type=template&id=0900f6ce"
import script from "./FDDetails.vue?vue&type=script&lang=js"
export * from "./FDDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__